var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFireProtection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64.04 57.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,18H6.6V15.8a6.59,6.59,0,0,1,6.6-6.6h10V2.6h-10A13.19,13.19,0,0,0,0,15.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3,24.2a12.1,12.1,0,0,1,24.2,0v.2h0V57.3H7.2V24.4h0C7.3,24.4,7.3,24.3,7.3,24.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "25.7 9.2 35.5 11.8 35.5 0 25.7 2.6 25.7 9.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5,57.3C46.7,50.6,52.2,46,58.2,42A16.68,16.68,0,0,0,61,39.5c4.5-4.7,3.6-13.8-.1-18.2a14.31,14.31,0,0,1-4.8,11.1c-1.7,1.7-3.8,3-5.6,4.7-2.4,2.2-5,4.3-6.8,6.9C41.1,47.9,40.9,52.3,42.5,57.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1,46.9c3.8-7,8.9-11.9,14.7-16.3a17.22,17.22,0,0,0,2.7-2.7c4.2-5,2.7-14-1.3-18.1a14.46,14.46,0,0,1-4.1,11.4c-1.6,1.8-3.6,3.3-5.3,5-2.2,2.3-4.7,4.6-6.3,7.3C36.2,37.6,36.2,42,38.1,46.9Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFireProtection);
export default __webpack_public_path__ + "static/media/icon-fire-protection.4b532d8d.svg";
export { ForwardRef as ReactComponent };